export const SIDEBAR_MENU = [
  { title: "Directory", path: "/members" },
  // { title: "Groups", path: "/groups", disabled: true },
  { title: "Chart Management", path: "/charts" },
  { title: "Teams", path: "/teams" },
  // {title:"My Program" ,path:"/myprogram"},
  // {title:"Directory" ,path:"/directory"},
  // {title:"Home" ,path:"/home"},
];

export const RESIDENT_MENU = [];

export const FACULTY_MENU = [];

export const MANAGER_MENU = [
  { title: "Directory", path: "/members" },
  // { title: "Groups", path: "/groups", disabled: true },
  { title: "Chart Management", path: "/charts" },

  { title: "Teams", path: "/teams" },

  // {title:"My Program" ,path:"/myprogram"},
  // {title:"Directory " ,path:"/directory"},
  // {title:"Home" ,path:"/home"},
];

export const SIDEBAR_MENU_WAYNE_STATE = [
  { title: "Directory", path: "/members" },
  { title: "Chart Management", path: "/charts" },

  { title: "Teams", path: "/teams" },
];
